import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import useProductInfo from '@/utils/hooks/useProductInfo';
import { useShoppingCart } from '@elem/compPage/wave-3-portable-air-conditioner/useShoppingCart';
import EcoBundle2 from 'eco-design/sections/eco-bundle-2';
import { useMemo } from 'react';
import { data1, data2, data3 } from './data';
import styles from './index.module.scss';

export default function JP_Bundles() {
    const { t } = useLang('theProduct.bundles');

    const urlList = [
        'https://jp.ecoflow.com/products/wave-3-portable-air-conditioner',
        'https://jp.ecoflow.com/products/wave-3-wave-3-smart-extra-battery',
        'https://jp.ecoflow.com/products/delta-3-plus-wave-3',
        'https://jp.ecoflow.com/products/delta-3-1500-wave-3',
        'https://jp.ecoflow.com/products/delta-3-plus-wave-3-500w-alternator-charger',
        'https://jp.ecoflow.com/products/delta-3-plus-wave-3-alternator-charger',
        'https://jp.ecoflow.com/products/delta-2-max-wave-3',
        'https://jp.ecoflow.com/products/delta-2-max-wave-3-alternator-charger',
    ];

    const getInfo = (i: any, idx: number, listName: string) => {
        const discount = Math.round((1 - i.price / (i.compareAtPrice || i.price)) * 100);
        const title = i.skuTitle === 'Default Title' ? i.productTitle : i.skuTitle;
        return {
            rChildren: i.inventoryQuantity <= 0 ? t('btn3') : t('btn1'),
            rDisabled: i.inventoryQuantity <= 0,
            rRadius: 'ellipse',
            lChildren: i.inventoryQuantity <= 0 ? '' : t('btn2'),
            lRadius: 'ellipse',
            lType: 'outlined',
            pointsTextL: '倍',
            // pointsTimes: 5,

            title,
            desc: t(`p${idx + 1}`),
            price: i.price,
            priceSuffix: '（税込）',
            comparePrice: i.compareAtPrice > i.price ? i.compareAtPrice : null,
            lDisabled: i.inventoryQuantity <= 0,
            rBtnClick() {
                handleAddCart([
                    {
                        originalPrice: i.compareAtPrice,
                        discountPrice: i.price,
                        img: i.variantImg,
                        productImg: i.img,
                        title,
                        productId: i.productId,
                        variantId: i.variantId,
                        quantity: 1,
                        inventory: i.inventoryQuantity,
                    },
                ]);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    list_name: listName,
                    product_name: title,
                    price: i.price,
                    tag: 'none',
                    quantity: 1,
                    button_name: t('btn1'),
                });
            },
            // lHref: `https://jp.ecoflow.com/cart/${i.variantId}:1?channel=buy_button`,
            lHref: `${urlList[idx]}?variant=${i.variantId}`,
            lDataLayer: {
                event: 'uaEvent',
                event_name: 'checkout',
                button_name: `${t('btn2')}_${title}`,
            },
            discountTextL: i.price && discount > 0 ? `${discount}% OFF` : '',
        };
    };

    const list1 = useProductInfo(data1);
    const items1 = useMemo(
        () =>
            list1.map((i) => ({
                imgs: [{ pc: i.variantImg || i.img }, i.staticImg],
                info: getInfo(i, 0, t('card1_title')),
            })),
        [list1],
    );
    const list2 = useProductInfo(data2);
    const items2 = useMemo(
        () =>
            list2.map((i) => ({
                imgs: [{ pc: i.variantImg || i.img }, i.staticImg],
                info: getInfo(i, 1, t('card2_title')),
            })),
        [list2],
    );
    const list3 = useProductInfo(data3);
    const items3 = useMemo(
        () =>
            list3.map((i, idx) => ({
                imgs: [{ pc: i.variantImg || i.img }, i.staticImg],
                info: getInfo(i, idx + 2, t('card3_title')),
            })),
        [list3],
    );

    // 购物车
    const { handleAddCart, Comp } = useShoppingCart();

    return (
        <div className={styles.bundles}>
            <EcoBundle2 items={items1} autoplay section={{ title: t('card1_title') }} />
            <EcoBundle2 items={items2} autoplay section={{ title: t('card2_title') }} />
            <EcoBundle2 items={items3} autoplay section={{ title: t('card3_title') }} />
            {Comp}
        </div>
    );
}
